"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFolderRequest = exports.FolderDetail = exports.FolderSummary = void 0;
const zod_1 = require("zod");
const script_1 = require("./script");
const rundown_1 = require("./rundown");
const common_1 = require("./common");
exports.FolderSummary = zod_1.z.object({
    id: common_1.Uuid,
    name: zod_1.z.string().nonempty(),
    parentId: common_1.Uuid,
    inTrash: zod_1.z.boolean(),
    isPrivate: zod_1.z.boolean(),
});
exports.FolderDetail = zod_1.z.intersection(exports.FolderSummary, zod_1.z.object({
    folders: zod_1.z.array(exports.FolderSummary),
    scriptListings: zod_1.z.array(script_1.ScriptListing),
    rundownListings: zod_1.z.array(rundown_1.RundownListing),
}));
exports.CreateFolderRequest = zod_1.z.object({
    name: zod_1.z.string().nonempty(),
    parentId: common_1.Uuid,
});
